export default "__VITE_ASSET__BtqH0Afx__"